import {
  AddMessageActionPayload,
  AddMessageActionFailPayload,
  AddMessageActionSuccessPayload,
  AddReactionPayload,
  ArchiveConversationPayload,
  InsertMessageActionPayload,
  MuteConversationActionPayload,
  RemoveMessageActionPayload,
  RemoveReactionPayload,
  SelectQuotedMessageActionPayload,
  SetConversationActionPayload,
  SetEditMessageActionPayload,
  SetMarkedMessageActionPayload,
  SetReactionPayload,
  SetUnreadMessagesCountPayload,
  SetUnreadMessageMarkerActionPayload,
  UnarchiveConversationPayload,
  UnmuteConversationActionPayload,
  UnselectQuotedMessageActionPayload,
  UpdateConversationActionPayload,
  UpdateMessageActionPayload,
} from './conversationProvider.types';

export enum ActionType {
  ADD_MESSAGE = 'ADD_MESSAGE',
  ADD_MESSAGE_FAIL = 'ADD_MESSAGE_FAIL',
  ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS',
  ADD_REACTION = 'ADD_REACTION',
  ARCHIVE_CONVERSATION = 'ARCHIVE_CONVERSATION',
  INSERT_MESSAGES = 'INSERT_MESSAGES',
  LOCK_SCROLL = 'LOCK_SCROLL',
  MUTE_CONVERSATION = 'MUTE_CONVERSATION',
  REMOVE_MESSAGE = 'REMOVE_MESSAGE',
  REMOVE_REACTION = 'REMOVE_REACTION',
  SELECT_QUOTED_MESSAGE = 'SELECT_QUOTED_MESSAGE',
  SET_CONVERSATION = 'SET_CONVERSATION',
  SET_MARKED_MESSAGE = 'SET_MARKED_MESSAGE',
  SET_EDIT_MESSAGE = 'SET_EDIT_MESSAGE',
  SET_REACTION = 'SET_REACTION',
  SET_UNREAD_MESSAGES_COUNT = 'SET_UNREAD_MESSAGES_COUNT',
  SET_UNREAD_MESSAGE_MARKER = 'SET_UNREAD_MESSAGE_MARKER',
  UNARCHIVE_CONVERSATION = 'UNARCHIVE_CONVERSATION',
  UNLOCK_SCROLL = 'UNLOCK_SCROLL',
  UNMUTE_CONVERSATION = 'UNMUTE_CONVERSATION',
  UNSELECT_QUOTED_MESSAGE = 'UNSELECT_QUOTED_MESSAGE',
  UPDATE_CONVERSATION = 'UPDATE_CONVERSATION',
  UPDATE_MESSAGE = 'UPDATE_MESSAGE',
}

export const addMessageAction = (payload: AddMessageActionPayload) =>
  ({
    payload,
    type: ActionType.ADD_MESSAGE,
  }) as const;

export const addMessageFailAction = (payload: AddMessageActionFailPayload) =>
  ({
    payload,
    type: ActionType.ADD_MESSAGE_FAIL,
  }) as const;

export const addMessageSuccessAction = (payload: AddMessageActionSuccessPayload) =>
  ({
    payload,
    type: ActionType.ADD_MESSAGE_SUCCESS,
  }) as const;

export const addReactionAction = (payload: AddReactionPayload) =>
  ({
    payload,
    type: ActionType.ADD_REACTION,
  }) as const;

export const archiveConversation = (payload: ArchiveConversationPayload) =>
  ({
    payload,
    type: ActionType.ARCHIVE_CONVERSATION,
  }) as const;

export const setConversationAction = (payload: SetConversationActionPayload) =>
  ({
    payload,
    type: ActionType.SET_CONVERSATION,
  }) as const;

export const insertMessagesAction = (payload: InsertMessageActionPayload) =>
  ({
    payload,
    type: ActionType.INSERT_MESSAGES,
  }) as const;

export const lockScrollAction = () =>
  ({
    type: ActionType.LOCK_SCROLL,
  }) as const;

export const muteConversationAction = (payload: MuteConversationActionPayload) =>
  ({
    payload,
    type: ActionType.MUTE_CONVERSATION,
  }) as const;

export const removeMessageAction = (payload: RemoveMessageActionPayload) =>
  ({
    payload,
    type: ActionType.REMOVE_MESSAGE,
  }) as const;

export const removeReactionAction = (payload: RemoveReactionPayload) =>
  ({
    payload,
    type: ActionType.REMOVE_REACTION,
  }) as const;

export const selectQuotedMessageAction = (payload: SelectQuotedMessageActionPayload) =>
  ({
    payload,
    type: ActionType.SELECT_QUOTED_MESSAGE,
  }) as const;

export const setEditMessageAction = (payload: SetEditMessageActionPayload) =>
  ({
    payload,
    type: ActionType.SET_EDIT_MESSAGE as typeof ActionType.SET_EDIT_MESSAGE,
  }) as const;

export const setMarkedMessageAction = (payload: SetMarkedMessageActionPayload) =>
  ({
    payload,
    type: ActionType.SET_MARKED_MESSAGE as typeof ActionType.SET_MARKED_MESSAGE,
  }) as const;

export const setReactionAction = (payload: SetReactionPayload) =>
  ({
    payload,
    type: ActionType.SET_REACTION,
  }) as const;

export const setUnreadMessagesCountAction = (payload: SetUnreadMessagesCountPayload) =>
  ({
    payload,
    type: ActionType.SET_UNREAD_MESSAGES_COUNT,
  }) as const;

export const setUnreadMessageMarkerAction = (payload: SetUnreadMessageMarkerActionPayload) =>
  ({
    payload,
    type: ActionType.SET_UNREAD_MESSAGE_MARKER,
  }) as const;

export const unarchiveConversationAction = (payload: UnarchiveConversationPayload) =>
  ({
    payload,
    type: ActionType.UNARCHIVE_CONVERSATION,
  }) as const;

export const unlockScrollAction = () =>
  ({
    type: ActionType.UNLOCK_SCROLL,
  }) as const;

export const unselectQuotedMessageAction = (payload: UnselectQuotedMessageActionPayload) =>
  ({
    payload,
    type: ActionType.UNSELECT_QUOTED_MESSAGE,
  }) as const;

export const unmuteConversationAction = (payload: UnmuteConversationActionPayload) =>
  ({
    payload,
    type: ActionType.UNMUTE_CONVERSATION,
  }) as const;

export const updateConversationAction = (payload: UpdateConversationActionPayload) =>
  ({
    payload,
    type: ActionType.UPDATE_CONVERSATION,
  }) as const;

export const updateMessageAction = (payload: UpdateMessageActionPayload) =>
  ({
    payload,
    type: ActionType.UPDATE_MESSAGE,
  }) as const;

export type Action =
  | ReturnType<typeof addMessageAction>
  | ReturnType<typeof addMessageFailAction>
  | ReturnType<typeof addMessageSuccessAction>
  | ReturnType<typeof addReactionAction>
  | ReturnType<typeof archiveConversation>
  | ReturnType<typeof insertMessagesAction>
  | ReturnType<typeof lockScrollAction>
  | ReturnType<typeof muteConversationAction>
  | ReturnType<typeof removeMessageAction>
  | ReturnType<typeof removeReactionAction>
  | ReturnType<typeof selectQuotedMessageAction>
  | ReturnType<typeof setConversationAction>
  | ReturnType<typeof setEditMessageAction>
  | ReturnType<typeof setMarkedMessageAction>
  | ReturnType<typeof setReactionAction>
  | ReturnType<typeof setUnreadMessagesCountAction>
  | ReturnType<typeof setUnreadMessageMarkerAction>
  | ReturnType<typeof unarchiveConversationAction>
  | ReturnType<typeof unlockScrollAction>
  | ReturnType<typeof unmuteConversationAction>
  | ReturnType<typeof unselectQuotedMessageAction>
  | ReturnType<typeof updateConversationAction>
  | ReturnType<typeof updateMessageAction>;
